'use client'

import { zodResolver } from '@hookform/resolvers/zod'
import React from 'react'
import { useForm } from 'react-hook-form'
import Button from '@/components/Form/Button'
import Input from '@/components/Form/Input'
import Modal from '@/components/Layout/Modal'
import { useApplyCoupon } from '@/hooks/business/cart'
import { CouponFormSchema, type ICouponForm } from '~/schemas/cart/coupon'

interface IApplyCouponModalProps {
    isCouponModalOpen: boolean
    setIsCouponModalOpen: (isOpen: boolean) => void
}

/**
 * Cupom digitado no carrinho. Aplica pelo `discountcode/apply-coupon` (ou troca, se já houver um) e fecha quando a API
 * aceita; recusado, o motivo sai no toast do service e o modal fica aberto para corrigir.
 */
const ApplyCouponModal: React.FC<IApplyCouponModalProps> = ({ isCouponModalOpen, setIsCouponModalOpen }) => {
    const { applyCoupon } = useApplyCoupon()

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm<ICouponForm>({ resolver: zodResolver(CouponFormSchema), defaultValues: { coupon: '' } })

    const handleAddCoupon = async ({ coupon }: ICouponForm) => {
        try {
            await applyCoupon(coupon)
            reset()
            setIsCouponModalOpen(false)
        } catch {
            // recusa já avisada no toast
        }
    }

    return (
        <Modal
            isOpen={isCouponModalOpen}
            onClose={() => setIsCouponModalOpen(false)}
            className="w-2/5 text-xl text-center"
        >
            <form onSubmit={handleSubmit(handleAddCoupon)}>
                <Input
                    labelText="Digite o cupom que deseja adicionar"
                    register={register('coupon')}
                    error={errors.coupon?.message}
                />
                <div className="flex max-md:flex-col gap-2 items-center justify-center mt-4 max-[850px]:flex-col-reverse">
                    <Button size="md" color="primary" type="button" onClick={() => setIsCouponModalOpen(false)}>
                        Cancelar
                    </Button>
                    <Button size="md" color="tertiary" type="submit" disabled={isSubmitting}>
                        Adicionar
                    </Button>
                </div>
            </form>
        </Modal>
    )
}

export default ApplyCouponModal
